module.exports = __webpack_public_path__ + "static/img/6.1.6da9a5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/5/6.1.png
// module id = 250
// module chunks = 0